import { connect } from 'react-redux';
import FetchEventComponent from './event-grant-ownership.component';
import { Dispatch } from 'types/dispatch';
import { eventApplyOwnership } from './event-grant-ownership.actions';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    eventApplyOwnership: () => {
        dispatch(eventApplyOwnership());
    }
});

const FetchEventContainer = connect(
    null,
    mapDispatchToProps
)(FetchEventComponent);

export default FetchEventContainer;
